import { useBloc as useBlocNext } from "@blac/react";
import React from "react";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";
import { DebugCheckbox } from "./debug.styles";

const DebugPartnerSession = () => {
  const [state, bloc] = useBlocNext(AppViewCubit);

  return (
    <div>
      <DebugCheckbox>
        <input
          type="checkbox"
          checked={Boolean(state.partnerSession)}
          onChange={() => bloc.togglePartnerSession()}
        />
        <span>Simulate Transcarent Session (SSO user)</span>
      </DebugCheckbox>
      <DebugCheckbox>
        <input
          type="checkbox"
          checked={Boolean(state.partnerStyles)}
          onChange={() => bloc.togglePartnerStyles()}
        />
        <span>Apply Partner Theme</span>
      </DebugCheckbox>
      <DebugCheckbox>
        <input
          type="checkbox"
          checked={Boolean(state.mobileTabNavigation)}
          onChange={() => bloc.toggleMobileTabNavigation()}
        />
        <span>Partner Mobile Navigation</span>
      </DebugCheckbox>
    </div>
  );
};

export default DebugPartnerSession;
